import { ActionReducerMap } from '@ngrx/store';

import * as fromRecommendedProducts from './reducers/recommended-products.reducer';
import * as fromPaymentMethods from './reducers/payment-methods.reducer';
import * as fromPnpBudget from './reducers/pnp-budget.reducer';
import * as fromInventoryAllocations from './reducers/inventory-allocations.reducer';
import * as fromInternalOrder from './reducers/internal-order.reducer';

import { AddressState, addressReducer } from './reducers/address.reducer';

export interface IAppState {
  recommendedProducts: fromRecommendedProducts.IRecommendedProductsState;
  paymentMethods: fromPaymentMethods.IPaymentsMethodsState;
  address: AddressState;
  pnpBudget: fromPnpBudget.IPnpBudgetState;
  inventoryAllocations: fromInventoryAllocations.IInventoryAllocationsState;
  internalOrder: fromInternalOrder.IInternalOrderState;
}

export const reducers: ActionReducerMap<IAppState> = {
  recommendedProducts: fromRecommendedProducts.recommendedProductsReducer,
  paymentMethods: fromPaymentMethods.paymentMethodsReducer,
  address: addressReducer,
  pnpBudget: fromPnpBudget.pnpBudgetReducer,
  inventoryAllocations: fromInventoryAllocations.inventoryAllocationsReducer,
  internalOrder: fromInternalOrder.internalOrderReducer,
};
